import { RMRectangle } from 'business/models/CustomModels';
import React, { useEffect, useState } from 'react';
import {
  useHitScoreGroup,
  useHitScoreGroupType,
  useSelectedHitButton,
} from 'redux/hooks/header';
import { ESelectedHitButton } from 'redux/reducers/headerReducer';
import { checkIsNonHitDrop } from '../utils';
import { IScoresOfWellDropsDTO } from 'business/models/Models';
import { CompositeRectsShape } from 'components/canvas/compositeRectsShape';

type UseDrawHitsProps = {
  wellDrops: any[];
  scores: { [key: string]: IScoresOfWellDropsDTO[] };
  wellRectangles: RMRectangle[];
};
const BatchIdLabel = 'Capture Result.Image Batch ID';

export const HitRectangles = (props: UseDrawHitsProps) => {
  const { wellDrops, scores, wellRectangles } = props;
  const hitScoreGroup = useHitScoreGroup();
  const hitScoreGroupType = useHitScoreGroupType();
  const hitButton = useSelectedHitButton();
  const [hitRectangles, setHitRectangles] = useState([]);

  useEffect(() => {
    if (hitButton === ESelectedHitButton.None || !wellDrops.length || !scores) {
      setHitRectangles([]);
      return;
    }

    const rects: RMRectangle[] = [];
    for (let i = 0; i < wellDrops.length; i++) {
      const dropId = wellDrops[i].__WellDropID;
      const batchId = wellDrops[i][BatchIdLabel];
      if (!dropId || !batchId) {
        continue;
      }

      //@ts-ignore
      const rect = wellRectangles[i].props;
      const wellScores = scores[`${dropId}-${batchId}`];

      const isNonHitDrop = checkIsNonHitDrop(
        wellScores,
        hitScoreGroupType,
        hitScoreGroup,
        hitButton,
      );

      if (isNonHitDrop) {
        const shape: RMRectangle = {
          x: rect.x + 1,
          y: rect.y,
          w: rect.width - 2,
          h: rect.height,
        };
        rects.push(shape);
      }
    }
    setHitRectangles(rects);
  }, [hitButton, hitScoreGroup, hitScoreGroupType]);

  return <CompositeRectsShape rectangles={hitRectangles} />;
};
